import { render, staticRenderFns } from "./CanvasOptBar.vue?vue&type=template&id=34ee9c98&scoped=true"
import script from "./CanvasOptBar.vue?vue&type=script&lang=js"
export * from "./CanvasOptBar.vue?vue&type=script&lang=js"
import style0 from "./CanvasOptBar.vue?vue&type=style&index=0&id=34ee9c98&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ee9c98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34ee9c98')) {
      api.createRecord('34ee9c98', component.options)
    } else {
      api.reload('34ee9c98', component.options)
    }
    module.hot.accept("./CanvasOptBar.vue?vue&type=template&id=34ee9c98&scoped=true", function () {
      api.rerender('34ee9c98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/canvas/components/editor/CanvasOptBar.vue"
export default component.exports